import { endPoints } from "./endPoints";
import axiosInstance from "../utils/axiosInstance";

export const signUpService = async (data) => {
  return await axiosInstance.post(endPoints.auth.signup, data, {
    hasLoader: false,
  });
};

export const addContact = async (data) => {
  return await axiosInstance.post(endPoints.auth.addContact, data, {
    hasLoader: false,
  });
};